export default "__VITE_ASSET__CEd8U9Vr__"